// import FeedbackSdk from 'amkit3-modules/utils/feedbackSdk';
import EventEmitter from 'amkit3-modules/utils/stateful-events'
import UIEvent from 'amkit3-modules/v/ui/ui-event'
import Toast from 'amkit3-modules/components/huya/Toast'
// import packjson from '../../../../package.json';

import themeFactory from './themes/factory'

class FeedBack extends EventEmitter {
  constructor($, $container) {
    super()

    this.$ = $
    this.$container = $container
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()
    this.showFeedback = false
    this.init()
  }
  init() {
    this.initStatus()
    this.initEvent()
  }
  // getVid() {
  //   let vid = 0;
  //   const { pathname } = location;
  //   const pathList = pathname.split('/');
  //   const fileName = pathList.pop();
  //   if (fileName) {
  //     vid = fileName.split('.')[0] || vid;
  //   }
  //   return vid;
  // }
  initStatus() {
    // this.feedbackInstance = new FeedbackSdk({
    //   appVersion: `Web视频站 ${packjson.version}`,
    //   anchorId: this.getVid(),
    //   subsid: 0,
    //   appId: 2700,
    //   isP2p: false,
    // });
  }
  initEvent() {
    this.$container.on('click', this.selector.controlBarFeedbackBtn, () => {
      this.toggleFeedback()
    })
    this.$container.on('click', this.selector.feedbackClose, () => {
      this.toggleFeedback(false)
    })
    this.$container.on(
      'click',
      this.selector.feedbackReason,
      this.statefulDelegate(evt => {
        let $target = this.$(evt.currentTarget) || this.$(evt.target)
        if (!$target.hasClass(this.style.feedbackReasonSelect)) {
          $target.addClass(this.style.feedbackReasonSelect)
          $target.siblings().removeClass(this.style.feedbackReasonSelect)
        }
      }),
    )
    this.$container.on('click', this.selector.feedbackSubmit, () => {
      this.toggleFeedback(false)
      if (
        !(
          this.$container.find(this.selector.feedbackReasonSelect).attr('index') === '8' &&
          this.$container.find(this.selector.feedbackTrouble).val().trim() === ''
        )
      ) {
        this.emit(UIEvent.FEEDBACK_SUBMIT, this.getFilledData())
      }
      this.clear()
    })
  }
  toggleFeedback(show) {
    const $feedback = this.$container.find(this.selector.feedback)
    this.showFeedback = show === undefined ? !this.showFeedback : show
    if (this.showFeedback) {
      $feedback.show()
    } else {
      $feedback.hide()
    }
  }
  getFilledData() {
    return {
      errorText: this.$container.find(this.selector.feedbackReasonSelect).text().trim(),
      content: JSON.stringify({
        detail: this.$container.find(this.selector.feedbackTrouble).val().trim(),
        qq: this.$container.find(this.selector.feedbackQQ).val().trim(),
      }),
    }
  }
  clear() {
    const $target = this.$container.find(this.selector.feedbackReasons).find('[index="8"]')
    $target.addClass(this.style.feedbackReasonSelect)
    $target.siblings().removeClass(this.style.feedbackReasonSelect)
    this.$container.find(this.selector.feedbackTrouble).val('')
    this.$container.find(this.selector.feedbackQQ).val('')
  }
}

export default FeedBack
